var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteLogo = function SvgWhiteLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 77 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.52 0v16.037l-3.943.816V11.88l-2.76 5.543-9.07 1.874V0h5.913v11.881L52.577.001z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5073DC",
    d: "M15.776 0v8.83l-3.944 2.648V0zM5.917 0V15.45L0 19.419V0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.75 17.818v5.94h-.003v.292l-3.03.626-.914-.917H0v-4.34l5.917-3.971v4.351h5.916v-8.322l3.944-2.647v8.988zM68.753 0C64.81 0 60.87 1.981 60.87 7.922v7.21l5.914-1.226V7.922c0-1.981 1.993-3.962 3.943-3.962H72.7v8.737l3.937-.816v-3.96c0-5.94-3.937-7.92-7.884-7.92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M76.635 11.882v3.959c0 5.94-3.943 7.919-7.89 7.919-1.973 0-3.943-.493-5.42-1.73s-2.464-3.219-2.464-6.189v-.698l5.914-1.226v5.886h1.97c1.95 0 3.947-1.98 3.947-3.962v-3.143zM28.933 19.803h-1.97V7.925c0-1.981 1.993-3.962 3.943-3.962h1.97v3.962h3.946c0-5.94-3.946-7.922-7.89-7.922L21.42 5.047c-.26.939-.385 1.91-.373 2.884v7.91c0 3.553 1.407 5.687 3.383 6.831l11.345-2.344c.655-1.154 1.045-2.621 1.045-4.487h-3.943c0 1.98-1.993 3.962-3.943 3.962"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5073DC",
    d: "M28.934.003 21.42 5.047C22.49 1.324 25.71.003 28.933.003"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.52 16.037v7.722h-3.944v-6.906zM49.816 17.424 46.66 23.76h-5.914v-4.462zM35.779 20.327c-1.437 2.5-4.14 3.432-6.845 3.432a9 9 0 0 1-4.5-1.087zM17.747 24.05v3.669l-3.03-3.043zM15.776 0v8.83l-3.944 2.648V0zM5.917 0V15.45L0 19.419V0zM28.934.003 21.42 5.047C22.49 1.324 25.71.003 28.933.003"
  })));
};
export default SvgWhiteLogo;